// Options for the chart that return on investment in money
// =============================================================================
import Highcharts from 'highcharts/highstock';

export default {
  chart: {
    panning: true
  },
  rangeSelector: {
    enabled: true,
    selected: 1
  },
  navigator: {
    enabled: true
  },
  scrollbar: {
    enabled: true
  },
  title: {
    text: 'Oversikt over avkastning',
    margin: 50
  },
  subtitle: {
    text: null
  },
  xAxis: {
    type: 'datetime',
    crosshair: {
      color: '#cccccc',
      dashStyle: 'Solid'
    }
  },
  yAxis: {
    opposite: true,
    offset: 50,
    labels: {
      align: 'right',
      x: -3,
      y: 4
    },
    title: {
      text: 'Kroner'
    }
  },
  tooltip: {
    shared: true,
    useHTML: true,
    footerFormat: '</tbody></table>',
    borderWidth: 0,
    valueDecimals: 2,
    formatter() {
      const dateFormat = '%A %e. %b %Y';
      let format =
        '<span style="font-size: 10px">%d</span><br>' +
        '<span style="color:%c">●</span> %s <b>%n kr</b><br>';

      format = format.replace('%c', Highcharts.getOptions().colors[0]);
      format = format.replace('%d', Highcharts.dateFormat(dateFormat, this.x));
      format = format.replace(
        '%n',
        Highcharts.numberFormat(this.points[0].y, 0)
      );
      format = format.replace('%s', 'Avkastning:');

      return format;
    }
  },
  series: [
    {
      lineWidth: 1
    }
  ]
};
